<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M9.75122 1.5105L9.75122 5.7605L14.0012 5.7605M9.75122 5.7605L14.7512 0.760498" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.0029 9.74878L9.75293 9.74878L9.75293 13.9988M9.75293 9.74878L14.7529 14.7488" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.75171 13.9998L5.75171 9.74976L1.50171 9.74976M5.75171 9.74976L0.751709 14.7498" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.5 5.75L5.75 5.75L5.75 1.5M5.75 5.75L0.75 0.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconCollapse'
}
</script>
